import React from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  subtitle,
  children,
  className = ''
}) => {
  return (
    <div className={`bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl p-4 shadow-lg shadow-teal-200 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-4">
          {children}
          
          <div>
            <h1 className="text-2xl font-bold text-white font-display">
              {title}
            </h1>
            {subtitle && (
              <p className="text-teal-100 font-admin mt-1">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
